import * as Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import vClickOutside from "click-outside-vue3"
import DCompanyRatings from "@components/organisms/DCompanyRatings.vue";
import companyCommon from "@modules/company-common";

$(window).on('load', function(e) {
  const mountEl = document.querySelector('#d-company-ratings');
  const app = Vue.createApp(DCompanyRatings, {...mountEl.dataset});
  app.use(vClickOutside);
  app.use(VueAxios, axios);
  app.mount('#d-company-ratings');

});

companyCommon()